import { PropsWithChildren } from 'react';
import { Tab } from '@headlessui/react';

export const TabContent = ({ children }: PropsWithChildren) => (
  <Tab.Panel className='outline-none'>{children}</Tab.Panel>
);
